import { dbClient } from '../db.js';

// Same pattern as categoryMaster.js: query on demand, fall back to a small
// hardcoded default list if the table is missing/unreachable, no persistent cache.

const DEFAULT_TEAM_TYPES = ['Normal', 'Project', 'Event', 'Department', 'Ethnic', 'Geographic', 'Global', 'Others'];
const DEFAULT_DEPARTMENTS = ['Operations', 'Temple', 'Gurukul', 'Finance', 'Legal', 'Causing', 'Annamandir', 'DR', 'Admin', 'Others'];
const DEFAULT_CURRENCIES = ['USD', 'INR', 'GBP', 'EUR', 'AED', 'XOF', 'DOP', 'RWF', 'UGX', 'KES', 'CAD', 'AUD'];

export async function loadTeamTypes() {
  try {
    const { data, error } = await dbClient
      .from('team_type_master')
      .select('id, name')
      .eq('is_active', true)
      .order('sort_order');
    if (error) throw error;
    if (!data?.length) return DEFAULT_TEAM_TYPES.map((name) => ({ name }));
    return data;
  } catch (e) {
    console.warn('team_type_master not available, using defaults:', e.message);
    return DEFAULT_TEAM_TYPES.map((name) => ({ name }));
  }
}

export async function loadDepartments() {
  try {
    const { data, error } = await dbClient
      .from('department_master')
      .select('id, name')
      .eq('is_active', true)
      .order('sort_order');
    if (error) throw error;
    if (!data?.length) return DEFAULT_DEPARTMENTS.map((name) => ({ name }));
    return data;
  } catch (e) {
    console.warn('department_master not available, using defaults:', e.message);
    return DEFAULT_DEPARTMENTS.map((name) => ({ name }));
  }
}

export async function loadCurrencies() {
  try {
    const { data, error } = await dbClient
      .from('currency_master')
      .select('code, name')
      .eq('is_active', true)
      .order('sort_order');
    if (error) throw error;
    if (!data?.length) return DEFAULT_CURRENCIES.map((code) => ({ code }));
    return data;
  } catch (e) {
    console.warn('currency_master not available, using defaults:', e.message);
    return DEFAULT_CURRENCIES.map((code) => ({ code }));
  }
}
